/**
 * Helpers to handle touch behaviors
 **/

/**
 * avoid browser pinch zoom gesture, only allow single touch point
 */
const replaceDefaultTouchBehavior = () => {
    document.querySelector("body").style.touchAction = "none";
    document.addEventListener("touchmove", documentOnTouchMove, { passive: false });


}

/**
 * Avoid the browser built-in touch events
 **/
const documentOnTouchMove = (e)=>{


    e.preventDefault();
}

/**
 * Restore to allow pinch zoom gesture
 */
const restoreDefaultTouchBehavior = () => {
    document.querySelector("body").style.touchAction = "auto";
    document.removeEventListener("touchmove", documentOnTouchMove);

}

/**
 *  set pinch-zoom so that when touchend is triggered after drawing is done, the page can be zoomed
 */
const setBodyPinchZoomOnly = () => {
    //set pinch-zoom so that when touchend is triggered after drawing is done, the page can be zoomed
    document.querySelector("body").style.touchAction = "pinch-zoom";
    document.removeEventListener("touchmove", documentOnTouchMove);


}

/**
 * Determine if there is more than one touch point
 * @param e
 */
const isMultiTouch = (e) => {
    return  e.touches &&  e.touches.length > 1;
}

export {
    replaceDefaultTouchBehavior,
    restoreDefaultTouchBehavior,
    isMultiTouch,
    setBodyPinchZoomOnly
}